module.exports = "<div class=\"col-md-12 m-v-sm\"> <div class={{vm.format[0]}} ng-repeat=\"data in vm.details\"> <div class=\"{{vm.format[1]}} no-padding word-wrap\"> <p class=\"text-sm exo no-margin p-r-md p-v-sm\"> {{ data[0] }}<span class=\"text-gris-dark proxima right w-h-100\">{{ data[1] }}<span> </span></span></p> </div> <div class=\"col-md-6 no-padding\" ng-if=vm.stackItems></div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/u-faculty/components/activities-review/activity-details/main-info.html
// module id = 474
// module chunks = 0